import React from "react";

const RadioInput = ({
  label,
  name,
  options = [],
  selectedValue,
  onChange,
  className = "",
  labelClassName = "",
  optionClassName = "",
  radioClassName = "",
  disabled = false,
  error = "",
}) => {
  return (
    <div
      className={`w-full h-[72px] shrink-0 grow-0 flex flex-col gap-1 ${className}`}
    >
      {label && (
        <label
          className={`text-body1 font-ptsans text-secondary/90 font-medium pl-2 block ${labelClassName}`}
        >
          {label}
        </label>
      )}
      <div className="flex gap-4 pl-3 pt-3">
        {options.map((option) => (
          <label
            key={option.value}
            className={`flex items-center cursor-pointer w-fit ${optionClassName}`}
          >
            <input
              type="radio"
              name={name}
              value={option.value}
              checked={selectedValue === option.value}
              onChange={() => onChange(option.value)}
              disabled={disabled}
              className={`mr-2 flex-shrink-0 appearance-none w-3 h-3 subtitle2 border border-secondary/20 bg-transparent rounded-full checked:bg-primary checked:border-primary
                ${
                  disabled
                    ? "cursor-not-allowed bg-secondary/35 border-secondary/20"
                    : "cursor-pointer focus:outline-none focus:ring-2 focus:ring-background_2"
                } ${radioClassName}`}
            />
            <span
              className={`text-body1 flex-shrink-0 ${
                disabled ? "text-secondary/35" : "text-secondary/85"
              }`}
            >
              {option.label}
            </span>
          </label>
        ))}
      </div>
      {error && (
        <span className="text-caption text-red-500 font-ptsans pl-2 pt-2">
          {error}
        </span>
      )}
    </div>
  );
};

export default RadioInput;
